import React from "react";
import ReactDOM from "react-dom";

import "./i18n";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import { configureStore } from "./redux/store";

// Suppress known error from react-modern-calendar-datepicker library
const originalError = console.error;
console.error = (...args: any[]) => {
  if (
    args[0]?.toString?.()?.includes?.("Cannot read properties of null (reading 'removeEventListener')") &&
    args[1]?.includes?.("react-modern-calendar-datepicker")
  ) {
    // Suppress this known library error
    return;
  }
  originalError.call(console, ...args);
};

ReactDOM.render(
  <Provider store={configureStore({})}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
